
import Base from '../../../../node_modules/vux/src/libs/base'
import Tip from '../../../../node_modules/vux/src/components/tip'
import Icon from '../../../../node_modules/vux/src/components/icon'
import InlineDesc from '../../../../node_modules/vux/src/components/inline-desc'
import { getValue, getLabels, getKey, getInlineDesc } from '../../../../node_modules/vux/src/components/checklist/object-filter'
import Grid from 'vux/src/components/grid/grid'
import GridItem from 'vux/src/components/grid/grid-item'
import XInput from 'vux/src/components/x-input/index'
import Datetime from 'vux/src/components/datetime/index'
import Rater from 'vux/src/components/rater/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XImg from 'vux/src/components/x-img/index.vue'


export default {
name: 'checklist',
directives: {
TransferDom
},
components: {
Rater,
Datetime,
XInput,
GridItem,
Grid,
Tip,
Icon,
InlineDesc,
Checker,
CheckerItem,
Cell,
Popup,
Flexbox,
FlexboxItem,
Group,
XImg
},
filters: {
getValue,
getKey
},
mixins: [Base],
props: {
name: String,
showError: Boolean,
showOk: Boolean,
title: String,
required: {
type: Boolean,
default: false
},
options: {
type: Array,
required: true
},
value: {
type: Array,
default: () => []
},
mchoice: Boolean,
max: Number,
min: Number,
fillMode: Boolean,
randomOrder: Boolean,
checkDisabled: {
type: Boolean,
default: true
},
labelPosition: {
type: String,
default: 'right'
},
disabled: Boolean
},
data () {
return {
showPopup: false,
currentShowOk: this.showOk,
currentValue: [],
currentOptions: this.options,
choiceValue: 0,
tempValue: '' 
}
},
beforeUpdate () {
if (this.isRadio) {
const length = this.currentValue.length
if (length > 1) {
this.currentValue = [this.currentValue[length - 1]]
}
const val = pure(this.currentValue)
this.tempValue = val.length ? val[0] : ''
for (let i = 0; i < this.options.length; i++) {
this.options[i].inputIndex = 2
if (this.currentValue[0] === this.options[i].id && this.options[i].inputMust === 1) {
this.options[i].inputIndex = 1
if (this.options[i].inputVal.trim() !== '') {
this.options[i].inputIndex = 2
}
}
}
}
},
created () {
this.handleChangeEvent = true
if (this.value) {
this.currentValue = this.value
if (this.isRadio) {
this.tempValue = this.isRadio ? this.value[0] : this.value
}
}
this.currentOptions = this.options
},
methods: {
getValue,
getKey,
getInlineDesc,
setCheck (checkDatas,index) {
this.$nextTick(function () {
this.currentIndex = index;
this.choiceValue =0;
if (checkDatas) {
this.choiceValue = checkDatas
}
this.showPopup = true
})

},
getFullValue () {
const labels = getLabels(this.options, this.value)
return this.currentValue.map((one, index) => {
return {
value: one,
label: labels[index]
}
})
},
isDisabled (key) {
if (!this.checkDisabled) {
return false
}
if (this._max > 1) {
return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max
}
return false
},
setInput (option) {
const _val = pure(option.id)
if (this.isRadio) {
this.currentValue = _val ? [_val] : []
} else {
this.currentValue.push(_val)
}
this.$emit('input', this.currentValue)
},
getGrape (item) {
this.$nextTick(function () {
let index = this.currentIndex;
this.currentOptions[index].inputVal = this.choiceValue;
this.showPopup = false
const val = pure(this.currentValue)
this.$emit('on-change', val, getLabels(this.options, val))

});
},
getGrape2 (item) {
this.$nextTick(function () {
const val = pure(this.currentValue)
this.$emit('on-change', val, getLabels(this.options, val))
});
},



















},
computed: {
isRadio () {
if (typeof this.max === 'undefined') {
return false
} else {
return this.max === 1
}
},
_total () {
return this.fillMode ? (this.options.length + 1) : this.options.length
},
_min () {
if (!this.required && !this.min) {
return 0
}
if (!this.required && this.min) {
return Math.min(this._total, this.min)
}
if (this.required) {
if (this.min) {
let max = Math.max(1, this.min)
return Math.min(this._total, max)
} else {
return 1
}
}
},
_max () {
if (!this.required && !this.max) {
return this._total
}
if (this.max) {
if (this.max > this._total) {
return this._total
}
return this.max
} else {
return this._total
}
},
valid () {
return this.currentValue.length >= this._min && this.currentValue.length <= this._max
}
},
watch: {
tempValue (val) {
const _val = val ? [val] : []
this.$emit('input', _val)
this.$emit('on-change', _val, getLabels(this.options, _val))
/* console.log(_val,1111,getLabels(this.options, _val)) */
},
value (newVal) {
if (JSON.stringify(newVal) !== JSON.stringify(this.currentValue)) {
this.currentValue = newVal
}
},
options (val) {
this.currentOptions = val
},
showOk (val) {
this.currentShowOk = val
},
currentValue (newVal) {
console.log(33333,555,newVal)
const val = pure(newVal)
this.$emit('input', val)
this.$emit('on-change', val, getLabels(this.options, val))
if (!this.isRadio) {
let err = {}
if (this._min) {
if (this.required) {
if (this.currentValue.length < this._min) {
err = {
min: this._min
}
}
} else {
if (this.currentValue.length && this.currentValue.length < this._min) {
err = {
min: this._min
}
}
}
}
if (!this.valid && this.dirty && Object.keys(err).length) {
this.$emit('on-error', err)
} else {
this.$emit('on-clear-error')
}
}
}
},
mounted () {
}
}
function pure (obj) {
return JSON.parse(JSON.stringify(obj))
}



// WEBPACK FOOTER //
// ./src/components/Subjects/Checklistspec/index.vue